export const regexValidator = (value, regex = /^[a-zA-Z0-9\s]*$/) => regex.test(value);

export const hexRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/i;

export const iframeRegex = /<iframe/i;

const MAX_TEXT_EDITOR_CHARS = 250;

export const textEditorValidator = (_, value) => {
  const text = value.replace(/<[^>]*>/g, '');
  if (text.length <= MAX_TEXT_EDITOR_CHARS) return Promise.resolve();
  return Promise.reject(new Error());
};
